import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, type BoxProps } from '@mui/material';

import { Typography } from '../Typography';

type Props = {
  onNavigatePrevious?: () => void;
  onNavigateNext?: () => void;
} & BoxProps;

export const NavigationButtons: FC<Props> = ({
  onNavigatePrevious,
  onNavigateNext,
  sx,
  ...boxProps
}) => {
  const { t } = useTranslation();

  if (!onNavigatePrevious && !onNavigateNext) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: 3,
        gap: 1,
        ...sx,
      }}
      {...boxProps}
    >
      <Box
        component="button"
        sx={{
          border: 'none',
          outline: 'none',
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
          borderRadius: '6px',
          py: 1,
          px: 1.5,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
          minWidth: 90,
          '&:hover:not(:disabled)': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
          '&:disabled': {
            opacity: 0.4,
            cursor: 'not-allowed',
          },
        }}
        onClick={onNavigatePrevious}
        disabled={!onNavigatePrevious}
        type="button"
      >
        <Typography variant="p3" color={onNavigatePrevious ? 'black' : 'gray'}>
          ← {t('virtualTour.cta.previous')}
        </Typography>
      </Box>
      <Box
        component="button"
        sx={{
          border: 'none',
          outline: 'none',
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
          borderRadius: '6px',
          py: 1,
          px: 1.5,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.5,
          minWidth: 90,
          '&:hover:not(:disabled)': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
          },
          '&:disabled': {
            opacity: 0.4,
            cursor: 'not-allowed',
          },
        }}
        onClick={onNavigateNext}
        disabled={!onNavigateNext}
        type="button"
      >
        <Typography variant="p3" color={onNavigateNext ? 'black' : 'gray'}>
          {t('virtualTour.cta.next')} →
        </Typography>
      </Box>
    </Box>
  );
};
